import { removeScheduleTailoredAudits } from "../controller/remove-schedule-tailored-audits"
import { isTailoredScheduleAuditingEnabled } from "./is-tailored-schedule-auditing-enabled"

export function removeTailoredAuditsFromSchedule({ tailoringReferenceId }) {
    if (!isTailoredScheduleAuditingEnabled) return
    removeScheduleTailoredAudits(tailoringReferenceId)
}
